export const FREQ_OPTIONS = [
  { value: 0, text: 'None' },
  { value: 24, text: '24h' },
  { value: 12, text: '12h' },
  { value: 6, text: '6h' },
  { value: 3, text: '3h' },
  { value: 1, text: '1h' },
]

export const IP_FRQ_LEVELS = [
  { value: 'l1', text: 'Level 1' },
  { value: 'l2', text: 'Level 2' },
  { value: 'l3', text: 'Level 3' },
  { value: 'l4', text: 'Level 4' },
  { value: 'l5', text: 'Level 5' },
]

export const SUB_OPTIONS = ['Sub1', 'Sub2', 'Sub3', 'Sub4', 'Sub6', 'Sub7', 'Sub8']

export const SUB_VALUES_LIMIT = 65000

export const CAMPAIGN_LINK_TEMPLATE = 'https://go.accesspointz.com/redirectV2?camp_id={camp_id}'

export function freqLbl(v) {
  const o = FREQ_OPTIONS.find(x => Number(x.value) === Number(v))
  return o ? o.text : 'None'
}

export function ipLevelLbl(v) {
  const o = IP_FRQ_LEVELS.find(x => x.value === v)
  return o ? o.text : 'Level 3'
}

export function campaignLink(campId) {
  return CAMPAIGN_LINK_TEMPLATE.replace('{camp_id}', campId)
}

export function normVals(raw) {
  return String(raw || '').split(/[,\n\r;\t]+/).map(s => s.trim()).filter(Boolean)
}

export function normStr(raw) {
  return normVals(raw).join(', ')
}

export function valCount(raw) {
  return normVals(raw).length
}

export function lostClass(pct) {
  if (pct >= 80) return 'hi'
  if (pct >= 40) return 'mid'
  return 'ok'
}

export function fmtNum(v) {
  const n = Number(isNaN(v) ? 0 : v)
  if (!n) return '0'
  return n.toLocaleString()
}

export function fmtPct(v) {
  const n = Number(v || 0)
  return n.toFixed(0) + '%'
}

export function subChips(rules) {
  const bl = []
  const wl = []
  ;(rules || []).forEach(r => {
    const num = String(r.sub || '').replace(/Sub/i, 'S')
    if (r.mode === 'whitelist') wl.push(num)
    else bl.push(num)
  })
  return { bl, wl }
}
